import { PageRef } from 'providers/page-ref';

export type PurchaseSuccessPageParams = {
  androidInstallUrl?: string;
  iosInstallUrl?: string;
};

export const IPurchaseSuccessPage: PageRef<PurchaseSuccessPageParams> = {
  pageName: 'PurchaseSuccessPage',
} as PageRef<PurchaseSuccessPageParams>;
